/*扣缴义务人*/
import { $http, buildHeaders } from "./index";

//获取扣缴义务人列表
export const withholdingagent_list = (params) => {
  return $http.get("/admin/WithholdingAgent/index", { params });
};

//获取第三方协议列表
export const withholdingagent_other_list = (withholding_agent_id) => {
  return $http.get("/admin/WithholdingAgent/getTaxTripleAgreementList", {
    params: {
      withholding_agent_id,
      limit: 0,
    },
  });
};

//设置默认
export const withholdingagent_other_setdefault = (data) => {
  return $http.post(
    "/admin/WithholdingAgent/setDefaultTaxTripleAgreement",
    data,
    {
      headers: buildHeaders(3),
    }
  );
};

//更新
export const withholdingagent_other_update = (data) => {
  return $http.post("/admin/WithholdingAgent/updateTaxTripleAgreement", data, {
    headers: buildHeaders(3),
  });
};

//获取扣缴义务人详情
export const withholdingagent_detail = (id) => {
  return $http.get("/admin/WithholdingAgent/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加扣缴义务人
export const withholdingagent_add = (data) => {
  return $http.post("/admin/WithholdingAgent/add", data, {
    headers: buildHeaders(3),
  });
};

//修改扣缴义务人
export const withholdingagent_edit = (data) => {
  return $http.post("/admin/WithholdingAgent/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除扣缴义务人
export const withholdingagent_delete = (id) => {
  return $http.post(
    "/admin/WithholdingAgent/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
